function normalize(str) {
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // quitar tildes
    .replace(/[^a-z\s]/g, "")
    .trim();
}

function tokenize(str) {
  return normalize(str).split(/\s+/).filter(Boolean);
}

// Jaccard
function jaccard(a, b) {
  const setA = new Set(a);
  const setB = new Set(b);
  const intersection = [...setA].filter(x => setB.has(x)).length;
  const union = new Set([...setA, ...setB]).size;
  return union === 0 ? 0 : intersection / union;
}

// Levenshtein simple
function levenshtein(a, b) {
  const dp = Array.from({ length: a.length + 1 }, () =>
    new Array(b.length + 1).fill(0)
  );

  for (let i = 0; i <= a.length; i++) dp[i][0] = i;
  for (let j = 0; j <= b.length; j++) dp[0][j] = j;

  for (let i = 1; i <= a.length; i++) {
    for (let j = 1; j <= b.length; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      dp[i][j] = Math.min(
        dp[i - 1][j] + 1,
        dp[i][j - 1] + 1,
        dp[i - 1][j - 1] + cost
      );
    }
  }

  return dp[a.length][b.length];
}

// similitud promedio por palabras
function wordSimilarity(tokensA, tokensB) {
  let total = 0;
  let count = 0;

  for (const a of tokensA) {
    let best = 0;

    for (const b of tokensB) {
      const dist = levenshtein(a, b);
      const maxLen = Math.max(a.length, b.length);
      const sim = 1 - dist / maxLen;
      if (sim > best) best = sim;
    }

    total += best;
    count++;
  }

  return count === 0 ? 0 : total / count;
}

// 🔥 función final
export function nameSimilarity(s1, s2) {
  const t1 = tokenize(s1);
  const t2 = tokenize(s2);

  const j = jaccard(t1, t2);
  const w = wordSimilarity(t1, t2);

  // pesos ajustables
  return 0.6 * j + 0.4 * w;
}